<script setup lang="ts">
import { computed } from "vue";
import OptionRow from "./OptionRow.vue";

const props = defineProps({
  modelValue: { type: String, default: null },
  defaultColor: { type: String, required: true },
  label: { type: String, default: "Color" },
  hint: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue"]);

const color = computed(() => props.modelValue || props.defaultColor);

function pick(value: string) {
  emit("update:modelValue", value.toLowerCase() === props.defaultColor.toLowerCase() ? null : value);
}
</script>

<template>
  <OptionRow
    :label="label"
    :hint="hint"
    inline>
    <label
      class="relative block size-6 shrink-0 cursor-pointer overflow-hidden rounded border border-border"
      :style="{ backgroundColor: color }"
      aria-label="Pick color">
      <input
        type="color"
        :value="color"
        class="sr-only"
        @input="pick(($event.target as HTMLInputElement).value)" />
    </label>
  </OptionRow>
</template>
